export default __webpack_public_path__ + "static/media/Group3.7e93bac2.svg";